// Browser-side Google geocoding (uses the working browser Maps key).
const LEVELS = { ROOFTOP: "exact", RANGE_INTERPOLATED: "street", GEOMETRIC_CENTER: "approx", APPROXIMATE: "city" };

// Returns { lat, lng, formatted_address, level } or null when nothing is found / Google unavailable.
export async function browserGeocode(address) {
  const q = (address || "").trim();
  const maps = window.google?.maps;
  if (!q || !maps?.importLibrary) return null;
  try {
    const { Geocoder } = await maps.importLibrary("geocoding");
    const { results } = await new Geocoder().geocode({ address: q, region: "us" });
    const top = results?.[0];
    if (top) {
      return {
        lat: top.geometry.location.lat(),
        lng: top.geometry.location.lng(),
        formatted_address: top.formatted_address,
        level: LEVELS[top.geometry.location_type] || "approx",
      };
    }
  } catch { /* ZERO_RESULTS or Geocoding disabled — try Places next */ }
  try {
    const { Place } = await maps.importLibrary("places");
    const { places } = await Place.searchByText({ textQuery: q, fields: ["location", "formattedAddress"], maxResultCount: 1, region: "us" });
    const p = places?.[0];
    if (p?.location) return { lat: p.location.lat(), lng: p.location.lng(), formatted_address: p.formattedAddress, level: "exact" };
  } catch { /* nothing found */ }
  return null;
}
